import React, {Component} from 'react';

class LineItem extends Component {
  constructor(props) {
    super(props);

    const imageSrc = this.props.line_item.variant.image && this.props.line_item.variant.image.src

    this.style = {
      backgroundImage: `url(${imageSrc})`
    }

    this.decrementQuantity = this.decrementQuantity.bind(this);
    this.incrementQuantity = this.incrementQuantity.bind(this);
  }

  decrementQuantity(lineItemId) {
    const updatedQuantity = this.props.line_item.quantity - 1
    this.props.updateQuantityInCart(lineItemId, updatedQuantity);
  }

  incrementQuantity(lineItemId) {
    const updatedQuantity = this.props.line_item.quantity + 1
    this.props.updateQuantityInCart(lineItemId, updatedQuantity);
  }

  render() {
    return (
      <li className="LineItem">
        <div className="LineItem__img" style={this.style}></div>
        <div className="LineItem__content">
          <div className="LineItem__content-row">
            <div className="LineItem__variant-title">
              {this.props.line_item.variant.title}
            </div>
            <span className="LineItem__title">
              {this.props.line_item.title}
            </span>
          </div>
          <div className="LineItem__content-row">
            <div className="LineItem__quantity-container">
              <button className="LineItem__quantity-update decrease" onClick={() => this.decrementQuantity(this.props.line_item.id)}>-</button>
              <span className="LineItem__quantity">{this.props.line_item.quantity}</span>
              <button className="LineItem__quantity-update" onClick={() => this.incrementQuantity(this.props.line_item.id)}>+</button>
            </div>
            <span className="LineItem__price">
              ${ (this.props.line_item.quantity * this.props.line_item.variant.price) }
            </span>
            <button className="LineItem__remove" onClick={()=> this.props.removeLineItemInCart(this.props.line_item.id)}>×</button>
          </div>
        </div>
      </li>
    );
  }
}

export default LineItem;
